module.exports = __webpack_public_path__ + "static/img/brand_back_spa_details.f3aae68.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/rm_brand_img/brand_back_spa_details.png
// module id = uhHz
// module chunks = 1